import { ReactNode } from 'react';

import { DrawerHeader as BaseDrawerHeader, Subhead, cn } from '@growtherapy/sprout-ui';

type DrawerHeaderProps = Omit<Parameters<typeof BaseDrawerHeader>[0], 'children'>;
type SubheadProps = Omit<Parameters<typeof Subhead.Default>[0], 'children'>;

export type DrawerHeaderViewProps = {
  children: ReactNode;
  isDarkTheme: boolean;
  drawerHeaderProps?: DrawerHeaderProps;
  headingProps?: SubheadProps;
};

export function DrawerHeader({ children, isDarkTheme, drawerHeaderProps, headingProps }: DrawerHeaderViewProps) {
  return (
    <BaseDrawerHeader {...drawerHeaderProps}>
      <Subhead.Default
        as='h2'
        className={cn({
          'rebrand:text-text-inverse': isDarkTheme,
        })}
        {...headingProps}
      >
        {children}
      </Subhead.Default>
    </BaseDrawerHeader>
  );
}
